import { jsx } from 'react/jsx-runtime';
import { composeEventHandlers } from '@radix-ui/primitive';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import { forwardRef, useRef, useLayoutEffect } from 'react';
import { focusLazy } from '../../../utils/focus.mjs';
import { BaseStaticInput } from '../SearchInput.mjs';
import { useSelectContext, useCollection } from './context.mjs';

const StaticInput = forwardRef(
  ({
    autoFocus,
    onKeyDown,
    value: valueProps,
    defaultValue,
    ...props
  }, forwardedRef) => {
    const ref = useRef(null);
    const composedRefs = useComposedRefs(ref, forwardedRef);
    const context = useSelectContext();
    const getItems = useCollection(void 0);
    useLayoutEffect(() => {
      if (autoFocus && ref.current) {
        focusLazy(ref.current);
      }
    }, [autoFocus]);
    return /* @__PURE__ */ jsx(
      BaseStaticInput,
      {
        ...props,
        onFocus: composeEventHandlers(props.onFocus, () => {
          context.onInputFocusChange(true);
        }),
        onBlur: composeEventHandlers(props.onBlur, () => {
          context.onInputFocusChange(false);
        }),
        getItems,
        ref: composedRefs,
        "aria-expanded": context.open ? "true" : "false"
      }
    );
  }
);

export { StaticInput as default };
//# sourceMappingURL=StaticInput.mjs.map
